import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import ContactSupportForm from "../component/layout/ContactSupportForm";
import "../component/layout/ContactSupportPage.scss";

type Props = {
  show: boolean;
  onHide: () => void;
};

function ContactSupportModal({ show, onHide }: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = useCallback(() => {
    if (isSubmitting) return;
    onHide();
  }, [isSubmitting, onHide]);

  const handleExited = useCallback(() => {
    requestAnimationFrame(() => {
      if (!document.querySelector(".modal.show")) {
        document.body.classList.remove("modal-open");
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
      }
    });
  }, []);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      onExited={handleExited}
      centered
      size="lg"
      enforceFocus={false}
      className="contact-support-bs-modal"
    >
      <Modal.Body className="p-0 border-0">
        <div className="contact-support-page contact-support-page--modal">
          <ContactSupportForm
            idPrefix="contact-support-modal"
            variant="modal"
            active={show}
            showCloseButton
            onClose={handleClose}
            onSuccess={onHide}
            onLoadingChange={setIsSubmitting}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ContactSupportModal;
